/*
 * @Description:
 * @Author: mdb
 * @Date: 2023-04-13 18:04:16
 * @LastEditTime: 2023-04-20 15:27:34
 * @LastEditors: mdb
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import i18n from '@/lang'

import { ConfigProvider, Button, Spin, Form, Input, Select, Textarea, Cascader, FormItem, Carousel } from 'ant-design-vue'
import CosSelect from '@/components/Antd/CosSelect/index.vue'
import ParamCodesSelect from '@/components/ParamCodesSelect'
import 'ant-design-vue/lib/button/style/css'
import 'ant-design-vue/lib/spin/style/css'
import 'ant-design-vue/lib/form/style/css'
import 'ant-design-vue/lib/input/style/css'
import 'ant-design-vue/lib/select/style/css'
import 'ant-design-vue/lib/cascader/style/css'
import '@dc-platform/dc-components/dist/style.css'

const antd = [ConfigProvider, Button, Spin, Form, Input, Select, Textarea, Cascader, FormItem, Carousel]

const renderApp = () => {
  const app = createApp(App)
  app.use(createPinia())
  app.use(i18n)

  antd.forEach((component) => {
    app.component(component.name, component)
  })
  app.component('CosSelect', CosSelect)
  app.component('ParamCodesSelect', ParamCodesSelect)

  app.use(router)
  app.mount('#app')
  return app
}
renderApp()
